export enum RejectionReason {
	NOT_IN_REGION = 'NOT_IN_REGION',
	IDLE = 'IDLE',
	MISBEHAVIOR = 'MISBEHAVIOR',
	DUPLICATE = 'DUPLICATE',
	INCOMPLETE_INFORMATION = 'INCOMPLETE_INFORMATION',
}
